import {
    MAIN_LOAD_FALSE, MAIN_LOAD_TRUE, DISPLAY_MESSAGE, DISPLAY_ERROR,
    SUCCESS_STATUS, OTP_VALID_FAILS, OTP_SENT_SUCCESS, OTP_VALID_SUCCESS,
    GET_CONSTITUTION_OF_FIRM,
    GET_CHANNEL_PARTNER,
    GET_PROJECTS,
    GET_CP_LEAD,
    GET_CP_DASHBOARD,
    GET_CP_LEAD_SITE_VISIT,
    CREATE_VENDOR,
    GET_CP_LEAD_DETAIL,
    GET_CALL_STATUS,
    GET_BD_USER,GET_COUNTRY_CODE
} from './types';

const initialState = {
    otp_sent: false,
    create_vendor: false,
    is_login: false,
    auth_user: {},
    img_url: 'https://www.goocampus.in/goocampus_new/',
    main_loader: false,
    message: "",
    error: "",
    status: "",

      user: [],

    getConstitutionOfFirm: {
        error: false,
        message: "",
        data: []
    },
    getChannelPartner: {
        error: false,
        message: "",
        data: []
    },
    getProjects: {
        error: false,
        message: "",
        data: []
    },
    getCpLead: {
        error: false,
        message: "",
        data: []
    },
    getCpLeadDetail: {
        error: false,
        message: "",
        data: []
    },

    getCpDashboard: {
        error: false,
        message: "",
        data: []
    },
    getCpLeadSiteVisit: {
        error: false,
        message: "",
        data: []
    },
    getCallStatus: {
        error: false,
        message: "",
        data: []
    },

getCountryCode:{
            error: false,
        message: "",
        data: []


}


}



const User_reducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case MAIN_LOAD_TRUE:
            return Object.assign({}, state, { main_loader: true });

        case MAIN_LOAD_FALSE:
            return Object.assign({}, state, { main_loader: false });

        case DISPLAY_MESSAGE:
            return Object.assign({}, state, { message: payload.message });

        case DISPLAY_ERROR:
            return Object.assign({}, state, { error: payload.error });

        case SUCCESS_STATUS:
            return Object.assign({}, state, { status: payload.status });

        case OTP_SENT_SUCCESS:
            return Object.assign({}, state, { otp_sent: true });
        case CREATE_VENDOR:
            return Object.assign({}, state, { create_vendor: true });
        case OTP_VALID_FAILS:
            return Object.assign({}, state, { valid_otp: false });

        case OTP_VALID_SUCCESS:
            return Object.assign({}, state, { valid_otp: true });
        case GET_CONSTITUTION_OF_FIRM:
            return Object.assign({}, state, { getConstitutionOfFirm: payload });
        case GET_CHANNEL_PARTNER:
            return Object.assign({}, state, { getChannelPartner: payload });
        case GET_PROJECTS:
            return Object.assign({}, state, { getProjects: payload });
        case GET_CP_LEAD:
            return Object.assign({}, state, { getCpLead: payload });
        case GET_CP_DASHBOARD:
            return Object.assign({}, state, { getCpDashboard: payload });
        case GET_CP_LEAD_SITE_VISIT:
            return Object.assign({}, state, { getCpLeadSiteVisit: payload });
        case GET_CP_LEAD_DETAIL:
            return Object.assign({}, state, { getCpLeadDetail: payload });
        case GET_CALL_STATUS:
            return Object.assign({}, state, { getCallStatus: payload });

                case GET_BD_USER:
      return Object.assign({}, state, { user: payload });


        case GET_COUNTRY_CODE:
      return Object.assign({}, state, { getCountryCode: payload });


      
        default:
            return state;
    }
}

export default User_reducer;